import { render, staticRenderFns } from "./TimelineDecade.vue?vue&type=template&id=2152a10a&"
import script from "./TimelineDecade.vue?vue&type=script&lang=js&"
export * from "./TimelineDecade.vue?vue&type=script&lang=js&"
import style0 from "./TimelineDecade.vue?vue&type=style&index=0&id=2152a10a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports